import {
    webpushLightningTryIt,
    webpushLightningMaybeLater,
    webpushLightningHeader,
    webpushLightningBody,
} from './LightableEnableWebPushCallout.locstring.json';
import loc from 'owa-localize';
/* tslint:disable:jsx-no-lambda WI:47650 */
import { completeWebPushLightningCallout } from '../actions/lightningCalloutActions';
import { observer } from 'mobx-react';
import { ButtonType, IButtonProps } from 'office-ui-fabric-react/lib/Button';
import { DirectionalHint } from 'office-ui-fabric-react/lib/common/DirectionalHint';
import { TeachingBubble } from 'office-ui-fabric-react/lib/TeachingBubble';
import { lightable, lighted, LightningProps } from 'owa-lightning-v2';

import * as React from 'react';

export interface LightableEnableWebPushCalloutProps extends LightningProps {
    target: () => HTMLElement;
}

@observer
@lightable
export class LightableEnableWebPushCallout extends React.Component<
    LightableEnableWebPushCalloutProps,
    {}
> {
    render() {
        let enableButtonProps: IButtonProps = {
            buttonType: ButtonType.primary,
            children: loc(webpushLightningTryIt),
            onClick: () => this.dismiss(true),
        };

        let dismissButtonProps: IButtonProps = {
            buttonType: ButtonType.primary,
            children: loc(webpushLightningMaybeLater),
            onClick: () => this.dismiss(false),
        };

        return (
            <TeachingBubble
                calloutProps={{
                    beakWidth: 15,
                    directionalHint: DirectionalHint.bottomAutoEdge,
                    preventDismissOnLostFocus: true,
                    preventDismissOnScroll: true,
                }}
                targetElement={this.props.target()}
                hasCloseIcon={true}
                onDismiss={() => this.dismiss(false)}
                hasSmallHeadline={true}
                isWide={true}
                headline={loc(webpushLightningHeader)}
                primaryButtonProps={enableButtonProps}
                secondaryButtonProps={dismissButtonProps}>
                {loc(webpushLightningBody)}
            </TeachingBubble>
        );
    }

    private dismiss = (enabled: boolean) => {
        lighted(this.props.lid, enabled ? 'Primary' : 'Secondary');
        completeWebPushLightningCallout(enabled);
    };
}
